import React from "react";
import {
  Box,
  Typography,
  Container,
  Button,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ctaButtonStyle from "../theme/ctaButtonStyle";

function IntroSection() {
  const navigate = useNavigate();

  const handleScrollToTemplates = () => {
    const el = document.getElementById("templates");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <Box
      sx={{
        py: { xs: 6, md: 8 },
        background: "linear-gradient(180deg, #FFF7F0 0%, #FFFFFF 100%)",
        borderBottom: "1px solid #F0E0D6",
      }}
    >
      <Container maxWidth="md">
        {/* Main Heading */}
        <Typography
          variant="h3"
          component="h1"
          align="center"
          sx={{
            fontWeight: 700,
            color: "#CC5500",
            mb: 3,
          }}
        >
          Free Online Marriage Biodata Maker
        </Typography>

        {/* Description */}
        {/* Description */}
        <Typography
          variant="body1"
          align="center"
          sx={{
            fontSize: "1.1rem",
            color: "#444",
            maxWidth: "720px",
            mx: "auto",
            mb: 3, // ⬅ slightly reduced to fit H2
            lineHeight: 1.8,
          }}
        >
          Create your marriage biodata online for free using our easy biodata maker. 
          Now available in English, Hindi (हिंदी), and Marathi (मराठी). 
          You can create, customize, and download marriage biodata in PDF format instantly. 
          Choose from modern and traditional biodata formats for Indian weddings without signup.
        </Typography>

        {/* ✅ NEW H2 */}
        <Typography
          variant="h5"
          component="h2"
          align="center"
          sx={{
            fontWeight: 600,
            color: "#333",
            mb: 5,
          }}
        >
          Free Marriage Biodata Maker in English, Hindi & Marathi – Create & Download Instantly
        </Typography>

        {/* CTA Buttons */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          justifyContent="center"
          alignItems="center"
        >
          <Button
            size="large"
            onClick={() => navigate("/create-biodata")}
            sx={ctaButtonStyle}
          >
            Create Biodata
          </Button>

          <Button
            size="large"
            variant="outlined"
            onClick={handleScrollToTemplates}
            sx={{
              px: 4,
              py: 1.4,
              fontSize: "1rem",
              fontWeight: 600,
              borderRadius: 2,
              borderColor: "#f57c00",
              color: "#f57c00",
              "&:hover": {
                backgroundColor: "rgba(245,124,0,0.08)",
                borderColor: "#ef6c00",
              },
            }}
          >
            View Templates
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}

export default IntroSection;
